/**
 * @generated SignedSource<<84f6a1804176f38d41a873250d7f763f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
export type FileAccessType = "public" | "signedUrl";
import { FragmentRefs } from "relay-runtime";
export type filesTableV2_FilesListFragment$data = {
  readonly Admin: {
    readonly Files: {
      readonly Files: {
        readonly __id: string;
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly accessType: FileAccessType;
            readonly fileType: string;
            readonly id: string;
            readonly name: string;
            readonly thumbnail: string | null;
            readonly uploadDateTime: string;
            readonly url: string | null;
          };
        } | null> | null;
        readonly pageInfo: {
          readonly endCursor: string | null;
          readonly hasNextPage: boolean;
          readonly hasPreviousPage: boolean;
          readonly startCursor: string | null;
        };
      };
    };
  };
  readonly " $fragmentType": "filesTableV2_FilesListFragment";
};
export type filesTableV2_FilesListFragment$key = {
  readonly " $data"?: filesTableV2_FilesListFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"filesTableV2_FilesListFragment">;
};

import FilesTableV2_Refetch_graphql from './FilesTableV2_Refetch.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "Admin",
  "Files",
  "Files"
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "filterByFileTypes"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "filterByFromDateTimeInclusive"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "filterByName"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "filterByToDateTimeInclusive"
    },
    {
      "defaultValue": [
        "IssuedCertificate"
      ],
      "kind": "LocalArgument",
      "name": "filterFileTagsExcluded"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "filterFileTagsIncluded"
    },
    {
      "defaultValue": 20,
      "kind": "LocalArgument",
      "name": "first"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": FilesTableV2_Refetch_graphql
    }
  },
  "name": "filesTableV2_FilesListFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AdminQueryType",
      "kind": "LinkedField",
      "name": "Admin",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "FilesAdminSchema",
          "kind": "LinkedField",
          "name": "Files",
          "plural": false,
          "selections": [
            {
              "alias": "Files",
              "args": [
                {
                  "kind": "Variable",
                  "name": "fileType",
                  "variableName": "filterByFileTypes"
                },
                {
                  "kind": "Variable",
                  "name": "fromDateTimeInclusive",
                  "variableName": "filterByFromDateTimeInclusive"
                },
                {
                  "kind": "Variable",
                  "name": "name",
                  "variableName": "filterByName"
                },
                {
                  "kind": "Variable",
                  "name": "tagsExcluded",
                  "variableName": "filterFileTagsExcluded"
                },
                {
                  "kind": "Variable",
                  "name": "tagsIncluded",
                  "variableName": "filterFileTagsIncluded"
                },
                {
                  "kind": "Variable",
                  "name": "toDateTimeInclusive",
                  "variableName": "filterByToDateTimeInclusive"
                }
              ],
              "concreteType": "FilesConnection",
              "kind": "LinkedField",
              "name": "__FilesTable_Files_connection",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "PageInfo",
                  "kind": "LinkedField",
                  "name": "pageInfo",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "endCursor",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasPreviousPage",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasNextPage",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "startCursor",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "FilesEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "File",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "id",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "name",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "fileType",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "accessType",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "uploadDateTime",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "thumbnail",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "url",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "__typename",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "cursor",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "kind": "ClientExtension",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__id",
                      "storageKey": null
                    }
                  ]
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "cb34281d29ba83716dbe7bce87222115";

export default node;
